type PropsT = {
  className?: string
  fillColor?: string
}

// Filled gift-box glyph. Replaces the `fa fa-gift` FontAwesome class
// previously used next to the feedback-inbox composer's "Remove reward"
// button (docs/06-ux-rules.md "Composer" / "Panel") — this repo's icons
// come from `components/Icons/*`, not FontAwesome classes.
const Gift = (props: PropsT) => {
  const { className, fillColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="gift-icon"
    >
      <path d="M20 7h-2.18a3 3 0 0 0-4.32-3.84L12 4.06l-1.5-.9A3 3 0 0 0 6.18 7H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM13 5.5A1.5 1.5 0 1 1 14.5 7H13V5.5zM9.5 4A1.5 1.5 0 0 1 11 5.5V7H9.5A1.5 1.5 0 0 1 9.5 4zM5 9h6v2H5V9zm1 4h5v6H6v-6zm12 6h-5v-6h5v6zm1-8h-6V9h6v2z" />
    </svg>
  )
}

export default Gift
